import React from 'react';

const Header = ({ onLogout, showChangePasswordModal }) => {
  return (
    <header className="bg-dark text-white p-3 d-flex justify-content-between align-items-center">
      <h4>BlogFortis</h4>
      <div className="dropdown">
        <button
          className="btn btn-secondry text-light dropdown-toggle"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i className="fa fa-right-from-bracket me-2" />
        </button>
        <ul className="dropdown-menu dropdown-menu-end">
          {/* <li>
            <button className="dropdown-item" onClick={() => alert('Profile Clicked')}>
              Profile
            </button>
          </li>
          <li>
            <button className="dropdown-item" onClick={() => showChangePasswordModal()}>
              Change Password
            </button>
          </li> */}
          {/* <li>
            <hr className="dropdown-divider" />
          </li> */}
          <li>
            <button className="dropdown-item text-danger" onClick={onLogout}>
              Logout
            </button>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Header;
